/* istanbul ignore file */
import { Tooltip, TooltipSize } from 'framework/ui/mui-builder';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import { SxProps } from '@mui/material';
import { FloatingPlacement } from 'framework/ui/uiContract';

interface Props {
  id: string;
  children: any;
  isBigText?: boolean;
  className?: string;
  placement?: FloatingPlacement | undefined;
  sxIcon?: SxProps;
}

const SimpleTooltip = ({ id, children, isBigText, className, sxIcon, placement = FloatingPlacement.RIGHT }: Props) => {
  return (
    <Tooltip title={children} placement={placement} id={id} size={isBigText ? TooltipSize.BIG : TooltipSize.DEFAULT}>
      <InfoIcon
        id={id}
        role="presentation"
        className={className}
        sx={[{ display: 'inline-block', ml: '0.3em' }, ...(Array.isArray(sxIcon) ? sxIcon : [sxIcon])]}
      />
    </Tooltip>
  );
};

export default SimpleTooltip;
